<div *ngIf="isLoading">
  <ng-content></ng-content>
</div>
<div *ngIf="error" class="flex-col-container items-center">
  <div class="message">{{'GLOBAL.ERRORS.SERVICE_ERROR' | translate}}</div>
</div>
<div *ngIf="empty" class="flex-col-container items-center">
  <div class="message">{{'GLOBAL.EMPTY.TITLE' | translate}}</div>
</div>
